export default __webpack_public_path__ + "static/media/Shoving Stab.88958c66.png";